import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-c-macronutrient-info',
  templateUrl: './c-macronutrient-info.component.html',
  styleUrls: ['./c-macronutrient-info.component.scss']
})
export class CMacronutrientInfoComponent implements OnInit {

  @Input() maxImageWidth = '30';
  @Input() proteins: number | undefined;
  @Input() lipids: number | undefined;
  @Input() carbohydrates: number | undefined;
  @Input() calories: number | undefined;
  @Input() fiber: number | undefined;
  @Input() title: string | undefined;
  @Input() subtitle: string | undefined;
  @Input() badgeColorHex = '#308398';
  @Input() showBadge = false;
  @Input() numberBlocks: number | undefined;

  constructor() { }

  ngOnInit(): void {
  }

}
